<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form">
    <el-row :gutter="10">
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('rfqid')"
          prop="rfqid"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.rfqid"
            @input="form.rfqid = valueTrimLeft($event)"
            @change="autoSaveField( 'rfqid')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('part')"
          prop="partID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-part-number
            :model.sync="form.partID"
            @update:model="autoSaveField('partID')"
          ></select-part-number>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('part-sn')"
          prop="partSN"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.partSN"
            @input="form.partSN = valueTrimLeft($event)"
            @change="autoSaveField('partSN')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('employee')"
          prop="employeeID"
          class="material-style">
          <select-response
            :model.sync="form.employeeID"
            @update:model="autoSaveField('employeeID')"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.isLoading"/>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('supplier')"
          prop="supplierCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.supplierCompanyID"
            @on-created="mixCreateSupplier"
            @on-change="mixChangeSupplierID"
          ></select-company>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('supplier-contact')"
          prop="supplierContactID"
          class="material-style">
          <select-company-contact
            :model.sync="form.supplierContactID"
            :companyID="form.supplierCompanyID"
            @update:model="autoSaveField('supplierContactID')"
          ></select-company-contact>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('release')"
          prop="releaseID"
          class="material-style"
        >
          <select-response
            :model.sync="form.releaseID"
            @on-change="autoSaveField('releaseID')"
            :data="dataSourceRelease.records"
            :isLoading="dataSourceRelease.loading"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style">
          <select-response
            :model.sync="form.conditionID"
            @update:model="autoSaveField('conditionID')"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :xs="6" :md="6" :lg="2">
        <el-form-item
          :label="L10n('qty')"
          prop="qty"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"
            @change="autoSaveField('qty')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="3">
        <el-form-item
          :label="L10n('price-min')"
          prop="priceMin"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.priceMin"
            @input="form.priceMin = valueNumber($event)"
            @change="autoSaveField('priceMin')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="3">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueNumber($event)"
            @change="autoSaveField('price')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="3">
        <el-form-item
          :label="L10n('price-max')"
          prop="priceMax"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.priceMax"
            @input="form.priceMax = valueNumber($event)"
            @change="autoSaveField('priceMax')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="2">
        <el-form-item
          prop="currencyID"
          class="material-style"
        >
          <select-response
            :model.sync="form.currencyID"
            @update:model="autoSaveField('currencyID')"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="5">
        <el-form-item
          :label="L10n('payment-term')"
          prop="paymentTermID"
          class="material-style">
          <select-response
            :model.sync="form.paymentTermID"
            @update:model="autoSaveField('paymentTermID')"
            :isLoading="dataSourcePaymentTerm.loading"
            :data="dataSourcePaymentTerm.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="6">
        <el-form-item
          :label="L10n('type-of-operation-condition')"
          prop="typeOfOperationConditionID"
          class="material-style">
          <select-response
            :model.sync="form.typeOfOperationConditionID"
            @update:model="autoSaveField('typeOfOperationConditionID')"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('traceability-company')"
          prop="traceabilityCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.traceabilityCompanyID"
            @on-change="autoSaveField('traceabilityCompanyID')"
            :disabled="disabledForm"
          >
          </select-company>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('tag-info-company')"
          prop="tagInfoCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.tagInfoCompanyID"
            @update:model="autoSaveField('tagInfoCompanyID')"
          >
          </select-company>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('tag-date')"
          prop="tagDate"
          class="material-style"
        >
          <date-picker
            v-model="form.tagDate"
            @change="autoSaveField('tagDate')"
          ></date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" :lg="6">
        <el-form-item
          :label="L10n('entry-date')"
          prop="entryDate"
          class="material-style"
        >
          <date-picker
            v-model="form.entryDate"
            @change="autoSaveField('entryDate')"
          ></date-picker>
        </el-form-item>
      </el-col>

      <el-col :xs="6" :md="6" :lg="4" :xl="2">
        <el-form-item
          :label="L10n('qty-received')"
          prop="qtyReceived"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.qtyReceived"
            @input="form.qtyReceived = valueNumber($event)"
            @change="autoSaveField('qtyReceived')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="6" :md="6" :lg="6" :xl="3">
        <el-form-item
          :label="L10n('delivery')"
          prop="delivery"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.delivery"
            @input="form.delivery = valueNumber($event)"
            @change="autoSaveField('delivery')"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="12" :lg="6" :xl="3">
        <el-form-item
          :label="L10n('received-date')"
          prop="receivedDate"
          class="material-style"
        >
          <date-picker
            v-model="form.receivedDate"
            @change="autoSaveField('receivedDate')"
          ></date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="12" :lg="8" :xl="4">
        <el-form-item
          :label="L10n('estimated-delivery-date')"
          prop="estimatedDeliveryDate"
          class="material-style"
        >
          <date-picker
            v-model="form.estimatedDeliveryDate"
            @change="autoSaveField('estimatedDeliveryDate')"
          ></date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="24" :lg="24" :xl="12">
        <el-form-item
          :label="L10n('reason-for-removal')"
          prop="reasonForRemoval"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.reasonForRemoval"
            @input="form.reasonForRemoval = valueTrimLeft($event)"
            @change="autoSaveField('reasonForRemoval')"
          />
        </el-form-item>
      </el-col>

      <el-col :xs="24" :md="24" :lg="24">
        <el-form-item
          :label="L10n('remarks')"
          prop="remarks"
          class="material-style">
          <el-input
            type="textarea"
            :rows="3"
            :value="form.remarks"
            @input="form.remarks = valueTrimLeft($event)"
            @change="autoSaveField('remarks')"/>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :md="12" :lg="8" :xl="3">
        <el-form-item
          :label="L10n('is-been-chosen')"
          prop="chosen"
          data-filed="true"
          class="material-style">
          <el-checkbox
            v-model="form.chosen"
            @change="autoSaveField('chosen')">
          </el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="12" :lg="8" :xl="3">
        <el-form-item
          :label="L10n('warranty-requested')"
          prop="warrantyRequested"
          data-filed="true"
          class="material-style">
          <el-checkbox
            v-model="form.warrantyRequested"
            @change="autoSaveField('warrantyRequested')">
          </el-checkbox>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateSupplier } from '@/mixins/companies'

export default {
  name: 'FormContacts',
  mixins: [Form, mixUpdateSupplier],
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue')
  },
  computed: {
    dataSourceDivision () {
      return this.API('Divisions/GetAllDynamic?select=id,title')
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title&orderBy=title')
    }
  },
  methods: {
  }
}
</script>
